/** @format */
'use client';
import { useConfigStore } from '@/providers/ConfigStoreProvider';
import { Role } from '@common/application/enums/Role';

export function useIsAdmin() {
  const role = useConfigStore((s) => s.role);
  const impersonatedRole = useConfigStore((s) => s.impersonatedRole);
  const userRole = impersonatedRole ?? role;
  const roles = [Role.User, Role.SuperUser, Role.Admin, Role.SuperAdmin];

  const hasRole = (roleToCheck: Role): boolean => {
    if (!userRole) {
      return false;
    }
    return roles.indexOf(userRole) >= roles.indexOf(roleToCheck);
  };

  const isAdmin = hasRole(Role.Admin);
  const isSuperAdmin = hasRole(Role.SuperAdmin);
  const isSuperUser = hasRole(Role.SuperUser);
  const isUser = hasRole(Role.User);
  const highestRole = impersonatedRole ?? role;
  return { isAdmin, isAdminChecked: !!role, isSuperAdmin, isSuperUser, isUser, highestRole };
}
